import { ProjectsReportRecord } from '../../types';
import { WidgetState } from '../state';
import { WidgetStateError } from './use-widget-data';

export const getAverageProjectsEndingDelay = (
  records: ProjectsReportRecord[],
): WidgetState<number, WidgetStateError> => {
  const projectsThatHasEndingDelay = records.filter(
    (x) => x.endingDelay != null,
  );

  if (projectsThatHasEndingDelay.length === 0) {
    return WidgetState.noData();
  }

  const totalEndingDelay = projectsThatHasEndingDelay.reduce(
    (total, { endingDelay }) => total + (endingDelay ?? 0),
    0,
  );

  const projectsEndingOnTime =
    totalEndingDelay / projectsThatHasEndingDelay.length;

  return WidgetState.data(Math.round(projectsEndingOnTime));
};
